// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"c6a07354","333":"33f9fb1b","635":"70622b7e","758":"80b9640c"}[chunkId] + ".chunk.js";
};